import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';

export const useAppInfo = () => {
  const { appConfig, featureFlags } = useConfigStore.getState();
  const isUser = localStorage.getItem('jwapp.auth') || localStorage.getItem('access_token') || localStorage.getItem('inplayer_token');
  const configId = featureFlags?.jwplayer?.config_id;
  const clientId = featureFlags?.inplayer?.client_id;
  const clientSite = appConfig?.branding?.client_site;
  const appVersion = featureFlags?.platforms?.web?.latest_version;
  const supportEmail = featureFlags?.common?.app_data?.support_email;

  const availableLanguages = featureFlags?.common.supported_languages;

  const termsOfUse = featureFlags?.common?.legal_docs.terms_of_use;
  const privacyPolicy = featureFlags?.common?.legal_docs?.privacy_policy;

  const landscapeThumbnail = appConfig?.branding?.video_horizontal_thumbnail;
  const portraitThumbnail = appConfig?.branding?.video_vertical_thumbnail;

  return {
    clientSite,
    supportEmail,
    availableLanguages,
    termsOfUse,
    privacyPolicy,
    landscapeThumbnail,
    portraitThumbnail,
    configId,
    clientId,
    appVersion,
    isUser,
  };
};
